import { render, staticRenderFns } from "./extensionInvitation.vue?vue&type=template&id=18f05e85&scoped=true"
import script from "./extensionInvitation.vue?vue&type=script&lang=js"
export * from "./extensionInvitation.vue?vue&type=script&lang=js"
import style0 from "./extensionInvitation.vue?vue&type=style&index=0&id=18f05e85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f05e85",
  null
  
)

export default component.exports